import React, { Component } from 'react'
import { checkTranslation, chooseFontColor, conditionalWidth, imageAddress, translate } from '../../utils/useful'
import BookingFrame from './BookingFrame'
import StaticFrame from './StaticFrame'
import DynamicFrame from './DynamicFrame'
import EmailFrame from './EmailFrame'
import SettingFrame from './SettingFrame'
import InqueriesFrame from './InqueriesFrame'
import HeaderInformation from './HeaderInformation'
import DeskFrame from './DeskFrame'
import CAHeaderInfo from './CAHeaderInfo'


export default class CAHeader extends Component {
    state = {
        bg: 'linear-gradient(90deg, #347f00, #42c200)',
        collapses: {},

    }
    componentDidMount() {

    }

    changeCollapse = () => {
        let main = this.state.main
        this.setState({ main: !main })
    }



    render() {
        let title = this.props?.config?.title
        if (title == '') {
            title = null
        }
        let info = this.props?.config?.info
        if (info == '') {
            info = null
        }

        let type = this.props.applet?.type

        if (!type && Array.isArray(this.props.applet?.features)) {
            type = this.props.applet.features[0]
        }
        let primaryColor = this.props.colors?.primaryColor ?? '#505050'
        let secondaryColor = this.props.colors?.secondaryColor ?? '#696969'
        let background = `linear-gradient(90deg, ${primaryColor}, ${secondaryColor})`



        return (
            <div className='w-100'>
                <div className='w-100 flexcc flex-column window-content-radius-top' style={{ zIndex: 1, background: background }}>

                    <CAHeaderInfo info={info} config={this.props?.config} headertype={this.props.headertype} addToCart={this.props.addToCart} types={this.props.types} cart={this.props.cart} functionsHandler={this.props.functionsHandler} showSettings={this.props.showSettings} colors={this.props.colors} showHome={this.props.showHome} title={title} applet={this.props.applet} page={this.props.page} width={this.props.width} backbtn={this.props.backbtn} backStage={this.props.backStage} goToHub={this.props.goToHub} changeWindow={this.props.changeWindow} changeWindowLink={this.props.changeWindowLink} data={this.props.data} />
                    {this.props.config?.showToolbar == true && (
                        <div className='flexcb w-100  sc-b px-2' style={{ background: this.props.colors?.iconInvert ? 'rgba(40, 40, 40, 0.04)' : 'rgba(255, 255, 255, 0.04)', overflowX: 'auto', height: '46px' }}>
                            <div className='flexc w-100'>




                                {this.props.config?.toolbar && (
                                    this.props.config.toolbar()
                                )}

                            </div>
                        </div>
                    )}
                </div>


            </div>

        )
    }
}
